import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';


@Injectable({ providedIn: 'root' })
export class SelectionService {
  private classID = new BehaviorSubject<string>(null);
	currentClassID = this.classID.asObservable();

	private studentID = new BehaviorSubject<string>(null);
	currentStudentID = this.studentID.asObservable();

	constructor() {}
	
	setClassID = (classID: string) => {
		this.classID.next(classID);
		localStorage.setItem('classID', this.classID.value);

		// TO CONFIRM THE LOGIC WITH DAVID
		// this.studentID.next(null);
		// localStorage.setItem('studentID', this.studentID.value);
	}
	
	getClassID = () => {
		return this.classID.value ? this.classID.value : localStorage.getItem('classID');
	}

	setStudentID = (studentID: string) => {
		this.studentID.next(studentID);
		localStorage.setItem('studentID', this.studentID.value);

		// TO CONFIRM THE LOGIC WITH DAVID
		// this.classID.next(null);
		// localStorage.setItem('classID', this.classID.value);
	}

	getStudentID = () => {
		return this.studentID.value ? this.studentID.value : localStorage.getItem('studentID');
	}
}
